// import 'es6-promise/auto'

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import shared from './shared'
import user from './user'
import debts from './debts'
import debtor from './debtor'
import cart from './cart'
import help from './help'
import reconciliation from './reconciliation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    shared: shared,
    user: user,
    debts: debts,
    debtor: debtor,
    cart: cart,
    help: help,
    reconciliation: reconciliation
  },
  plugins: [createPersistedState({ storage: window.localStorage, paths: ['user'] })]
})
